class di extends HTMLElement {
    constructor() {
        super(), (this.removeId = null), (this.lastReloadTime = 0);
    }
    connectedCallback() {
        this.addToCart(), this.addTriggers(), this.checkParams();
        const e = this;
        document.querySelectorAll(".open-sidecart").forEach((t) => {
            t.addEventListener("click", () => {
                e.openCart();
            });
        });
    }
    openCart() {
        this.classList.remove("translate-x-full"),
            document.body.classList.add("overflow-hidden"),
            setTimeout(() => {
                this.querySelector(".side-cart-overlay").classList.remove("hidden");
            }, 300),
            this.renderCart();
    }
    closeCart() {
        this.querySelector(".side-cart-overlay").classList.add("hidden"), this.classList.add("translate-x-full"), document.body.classList.remove("overflow-hidden");
    }
    reloadNosto() {
        const e = Date.now();
        
        // e - this.lastReloadTime < 1e3 ||
        //     ((this.lastReloadTime = e),
        //     Nosto.reloadCart(),
        //     setTimeout(() => {
        //         this.querySelector("#minicart-replace").setAttribute("style", "display: block !important;");
        //     }, 300));
    }
    observeNostoClicks() {
        const e = document.querySelectorAll(".nosto-atc");
        e.length > 0 &&
            e.forEach((t) => {
                if (!t.hasAttribute("data-nosto-listener")) {
                    t.addEventListener("click", () => {
                        setTimeout(() => {
                            this.renderCart();
                        }, 1250);
                    });
                    t.setAttribute("data-nosto-listener", "true");
                }
            });
    }
    renderCart() {
        fetch(window.Shopify.routes.root + "?sections=sidecart")
            .then((e) => e.json())
            .then((e) => {
                var o, a, l;
                let t = document.createElement("div");
                (t.innerHTML = e.sidecart),
                    (document.getElementById("sidecart-inner").innerHTML = t.querySelector("#sidecart-inner").innerHTML),
                    (o = document.querySelector(".sidecart-items")) == null || o.classList.remove("opacity-80"),
                    this.reloadNosto(),
                    [100, 2222, 4444, 9999].forEach((d) => {
                        setTimeout(() => {
                            this.observeNostoClicks(),
                                document.querySelectorAll(".sidecart__close-cart").forEach((c) => {
                                    c.addEventListener("click", () => {
                                        this.querySelector(".side-cart-overlay").classList.add("hidden"), this.closeCart(), this.classList.add("translate-x-full");
                                    });
                                });
                        }, d);
                    }),
                    (document.querySelector(".sidecart__subtotal").innerHTML = t.querySelector("side-cart").dataset.currency + "" + t.querySelector("side-cart").dataset.subtotal);
                const r = document.querySelectorAll(".sidecart-item"),
                    n = document.getElementById("cart-count");
                r.length > 0
                    ? (n && ((n.innerText = r.length), n.classList.remove("hidden")), (a = this.querySelector(".side-cart__total--container")) == null || a.classList.remove("hidden"))
                    : (l = this.querySelector(".side-cart__total--container")) == null || l.classList.add("hidden");
            });

            document.querySelector("sms-gwp")?.handleGWP();
    }
    addToCart() {
        const e = this;
        this.addEventListener("click", function (t) {
            var r;
            let i = t.target;
            if (i.classList.contains("sidecart__add")) {
                let n = { id: i.dataset.id, quantity: i.dataset.quantity };
                i.dataset.sellingPlan && (n.selling_plan = i.dataset.sellingPlan),
                    (r = document.querySelector(".sidecart-items")) == null || r.classList.add("opacity-80"),
                    fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(n) })
                        .then((o) => o.json())
                        .then((o) => {
                            e.renderCart();
                        })
                        .catch((o) => {
                            console.error("Error adding product to cart:", o);
                        });
            }
        });
    }
    addTriggers() {
        const e = this;
        this.addEventListener("click", function (t) {
            let i = t.target;
            if ((i.classList.contains("sidecart__checkout") && (window.location.href = "/checkout"), i.classList.contains("sidecart__remove") && ((e.removeId = i.dataset.id), e.removeItem()), i.classList.contains("quantity__button"))) {
                const r = i.dataset.action,
                    n = i.closest(".sidecart-item").dataset.id,
                    o = parseInt(i.closest(".sidecart-item").querySelector(".quantity__input").value);
                let a;
                r === "increment" ? (a = o + 1) : r === "decrement" && (a = o - 1),
                    fetch(window.Shopify.routes.root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: n, quantity: a }) })
                        .then((l) => l.json())
                        .then((l) => {
                            if (l.status === 422) {
                                alert(l.message);
                                return;
                            } else e.renderCart();
                            document.querySelector("sms-gwp")?.handleGWP();
                        })
                        .catch((l) => {
                            alert("Error updating cart " + l);
                        });
            }
        });
    }
    removeItem() {
        var r;
        const e = this;
        (r = document.querySelector(".sidecart-items")) == null || r.classList.add("opacity-80");
        const t = document.querySelectorAll(".sidecart-item");
        Array.from(t).filter((n) => n.dataset.id !== e.removeId).length > 0
            ? fetch(window.Shopify.routes.root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: e.removeId, quantity: 0 }) })
                  .then((n) => n.json())
                  .then((n) => {
                      e.renderCart();
                      document.querySelector("sms-gwp")?.handleGWP();
                  })
                  .catch((n) => {
                      console.error("Error removing product from cart:", n);
                  })
            : fetch(window.Shopify.routes.root + "cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
                  .then((n) => n.json())
                  .then((n) => {
                      e.renderCart();
                  })
                  .catch((n) => {
                      console.error("Error clearing cart:", n);
                  });
    }
    checkParams() {
        new URLSearchParams(window.location.search).get("cart") === "open" && this.openCart();
    }
}
customElements.define("side-cart", di);
